<template>
  <div
    class="flex h-[22px] items-center justify-center rounded-2xl"
    :class="{
      [variant]: variant,
      'px-2 py-[2px] text-xs font-medium': size === 'sm',
      'px-4 py-2 text-sm font-normal': size === 'md',
      'px-4 py-2 text-base font-medium': size === 'lg',
    }"
  >
    <slot> </slot>
  </div>
</template>

<script>
export default {
  name: 'ImoBadge',
  props: {
    variant: {
      type: String,
      validators: value =>
        ['primary', 'secondary', 'error', 'success', 'warning', 'info', 'neutral'].includes(value),
      default: 'primary',
    },
    size: {
      type: String,
      default: 'sm',
      validators: value => ['sm', 'md', 'lg'].includes(value),
    },
  },
}
</script>

<style scoped>
@reference "@/assets/style/main.css";

.primary {
  @apply bg-primary-0 text-primary-80;
}

.secondary {
  @apply bg-secondary-0 text-secondary-50;
}

.error {
  @apply bg-error-20 text-error-70;
}

.success {
  @apply bg-success-20 text-success-80;
}

.warning {
  @apply bg-warning-20 text-warning-80;
}

.info {
  @apply bg-info-10 text-info-80;
}

.neutral {
  @apply bg-neutral-20 text-neutral-70;
}
</style>
